import React, { useState, useEffect } from "react";
import { formatNum, parseNum } from "@/lib/brand";

/**
 * MoneyInput — typed numeric input that displays comma-separated thousands on blur.
 * Stores plain Number in `value`. Calls `onChange(number)` on every keystroke.
 */
export default function MoneyInput({
  value,
  onChange,
  placeholder = "0",
  prefix = "£",
  testid,
  className = "input",
  allowNegative = false,
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");

  useEffect(() => {
    if (!editing) {
      setDraft(value === "" || value === null || value === undefined ? "" : formatNum(value));
    }
  }, [value, editing]);

  const handleChange = (e) => {
    const raw = e.target.value;
    setDraft(raw);
    const n = parseNum(raw);
    onChange(allowNegative ? n : Math.max(0, n));
  };

  return (
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-black/55 pointer-events-none select-none text-sm">
          {prefix}
        </span>
      )}
      <input
        className={className}
        style={prefix ? { paddingLeft: "1.7rem" } : undefined}
        data-testid={testid}
        value={draft}
        placeholder={placeholder}
        onFocus={(e) => {
          setEditing(true);
          const el = e.target;
          requestAnimationFrame(() => el.select());
          // Strip commas while typing AND clear a stale "0" placeholder so the user
          // doesn't end up with something like "0123" or "1230" after typing.
          setDraft((d) => {
            const stripped = d.replace(/,/g, "");
            return stripped === "0" || stripped === "0.00" || stripped === "0." ? "" : stripped;
          });
        }}
        onBlur={() => {
          setEditing(false);
          const rounded = Math.round(Number(value) || 0);
          if (value !== "" && value !== null && value !== undefined && rounded !== Number(value)) onChange(rounded);
          setDraft(value === "" || value === null || value === undefined ? "" : formatNum(rounded));
        }}
        onChange={handleChange}
        inputMode="numeric"
      />
    </div>
  );
}
